import React from 'react';
import PropTypes from 'prop-types';

import useIsMobile from '../../../services/hooks/use-is-mobile';

const DesktopView = ({
  children,
}) => {
  const isMobile = useIsMobile();

  return (
    <>
      {!isMobile ? children : null}
    </>
  );
};

DesktopView.propTypes = {
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default DesktopView;
